
import Component from '../../../assets/scripts/modules/component'

const DEFAULT_DURATION = 32

class ModuleMarqueeComponent extends Component {
  init () {
    this.track = this.element.querySelector('.module-marquee__track')

    if (!this.track) {
      return
    }

    this.track.style.animationDuration = (Math.round(this.track.innerText.length / 8) || DEFAULT_DURATION) + 's'
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.module-marquee')) {
    element.instance = element.instance || new ModuleMarqueeComponent(element)
  }
})
